import styled from 'styled-components';
import React from 'react';
import { Product } from '../models/Product';

interface CardProductProps {
  product: Product;
}

const CardProduct: React.FC<CardProductProps> = ({ product }) => {

  const formatPrice = (price: string) => {
    const numericPrice = parseFloat(price);
    const formattedPrice = numericPrice % 1 === 0 ? numericPrice.toFixed(0) : numericPrice.toFixed(2);
    return `R$${formattedPrice}`;
  };

  const Card = styled.div`
    width: 190px;
    height: 250px;
    padding: 10px 20px;
    background-color: white;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
    margin-top: 10px;
    border: none;
    border-radius: 8px;
    background-position: center;
    background-size: cover;
    cursor: pointer;
  `;

  const CardColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
  `;

  const Image = styled.img`
    max-width: 70%;
    max-height: 50%;
    border-radius: 5px;

    margin-top: 20px;
  `;

  const StyledRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 10px 0;
  `;

  const StyledBuy = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: #0F52BA;
    color: white;
    padding: 10px 20px;
    width: 100%;

    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    transition: background-color 0.3s ease;

    &:hover {
    background-color: #0c3a8e;
    i {
      transform: scale(1.2);
    }
  }
  `;

  const ProductTitle = styled.h3`
    font-weight: 600;
    font-size: 14px;
    margin: 10px 0;
  `;

  const ProductDescription = styled.p`
    font-size: 10px;
    margin: 0px 0px 15px 0px;
    color: #2C2C2C;
  `;

  const ProductPrice = styled.p`
    font-size: 12px;
    margin: 5px 0;
    padding: 5px;
    border-radius: 5px;
    font-weight: bold;
    color: white;
    background: #373737;
  `;

  const Icon = styled.i`
    transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

  return (
    <Card>
      <CardColumn>
        <Image src={product.photo} alt={product.name} />
        <StyledRow>
          <ProductTitle>{product.name}</ProductTitle>
          <ProductPrice>{formatPrice(product.price)}</ProductPrice>
        </StyledRow>
        <ProductDescription>{product.description}</ProductDescription>
        <StyledBuy>
          <Icon className="fa-solid fa-basket-shopping"></Icon>
          <h5>COMPRAR</h5>
        </StyledBuy>
      </CardColumn>
    </Card>
  );
};

export default CardProduct;